import { useCallback, useState } from 'react';

export type TemplateModalState = 'none' | 'browser' | 'detail' | 'customization' | 'builder';

export function useTemplateModalState() {
  const [templateModal, setTemplateModal] = useState<TemplateModalState>('none');

  const setActiveTemplateModal = useCallback((modal: Exclude<TemplateModalState, 'none'> | null) => {
    setTemplateModal(modal ?? 'none');
  }, []);

  return {
    templateModal,
    setTemplateModal,
    setActiveTemplateModal,
    showTemplateBrowser: templateModal === 'browser',
    showTemplateDetail: templateModal === 'detail',
    showTemplateCustomization: templateModal === 'customization',
    showTemplateBuilder: templateModal === 'builder',
  };
}
